import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import WhatsAppButton from './Whatsapp';
import { CiLocationArrow1 } from "react-icons/ci";
import { FaSquarePhone, FaWhatsapp, FaRegEnvelope } from "react-icons/fa6";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const handlenavigate = () => {
    navigate('/');
  };

  return (
    <>
      {location.pathname !== '/' && (
        <div className='fixed point2 blink' onClick={handlenavigate} title="View Price List & Order">
          <img src={require('../../assets/images/quickpurchase.png')} className='img-fluid priceicn2 float-right' alt='Order Crackers Now' />
        </div>
      )}

      {/* Floating Action Buttons */}
      <div className='fixed point' title="WhatsApp Us">
        <WhatsAppButton name="Alagar Crackers" phoneNumber="919342113123" />
      </div>

      <a href="https://maps.app.goo.gl/M9bD62NWEtL2kUfdA" target="_blank" rel="noopener noreferrer" title="View Store Location">
        <div className="fixed point3" style={{ cursor: 'pointer' }}>
          <img src={require('../../assets/images/googlelocation.png')} className='img-fluid priceicn float-left' alt='Google Maps Location' />
        </div>
      </a>

      <a href='tel:+919342113123' title="Call Us Directly">
        <div className='fixed point4' style={{ cursor: 'pointer' }}>
          <img src={require('../../assets/images/callicon.webp')} className='img-fluid priceicn float-left' alt='Call Us' />
        </div>
      </a>

      {/* Main Footer */}
      <div className='footer-bg foot-pad'>
        <Container className='z'>
          <Row className='gy-4'>
            <Col lg='4' md='6'>
              <div className='ft-logo mb-3'>
                <img src={require('../../assets/images/storelogo.png')} className='img-fluid logo-circle' alt='Alagar Crackers' />
              </div>
              <div className='regular text-light pe-lg-4' style={{ lineHeight: 1.7, fontSize: '14.5px' }}>
                Light up your Diwali celebrations with our spectacular direct Sivakasi crackers! Enjoy factory wholesale prices, supreme quality fireworks, and fast delivery across India.
              </div>
              <div className='mt-3 d-inline-flex align-items-center gap-2 px-3 py-1 bg-white bg-opacity-10 rounded-pill'>
                <span style={{ color: '#fbbf24', fontSize: '13px' }}>⭐ 100% Sivakasi Genuine Quality</span>
              </div>
            </Col>

            <Col lg='5' md='6'>
              <h4 className='bold text-white mb-3'>Contact Details</h4>
              <ul className='list-unstyled p-0'>
                <li className='d-flex align-items-start gap-3 py-2'>
                  <span className='ft-icon'><CiLocationArrow1 size={20} /></span>
                  <div style={{ fontSize: '14px', lineHeight: 1.6 }}>
                    <strong>Alagar Crackers</strong><br />
                    Sankarankovil Rd, Muthugudi,<br />
                    Rajapalayam, Sivakasi Region, Tamil Nadu - 626117
                  </div>
                </li>
                <li className='d-flex align-items-center gap-3 py-2'>
                  <span className='ft-icon'><FaSquarePhone size={18} /></span>
                  <div style={{ fontSize: '14.5px' }}>
                    <a href="tel:+919342113123" className='text-white text-decoration-none'>+91 93421 13123</a>
                  </div>
                </li>
                <li className='d-flex align-items-center gap-3 py-2'>
                  <span className='ft-icon' style={{ background: '#10b981' }}><FaWhatsapp size={18} /></span>
                  <div style={{ fontSize: '14.5px' }}>
                    <a href="https://wa.me/919342113123?text=Hello%20Alagar%20Crackers" target="_blank" rel="noopener noreferrer" className='text-white text-decoration-none'>+91 93421 13123</a>
                  </div>
                </li>
                <li className='d-flex align-items-center gap-3 py-2'>
                  <span className='ft-icon' style={{ background: '#ef4444' }}><FaRegEnvelope size={16} /></span>
                  <div style={{ fontSize: '14.5px' }}>
                    <a href="mailto:alagarcrackers@gmail.com" className='text-white text-decoration-none'>alagarcrackers@gmail.com</a>
                  </div>
                </li>
              </ul>
            </Col>

            <Col lg='3' md='12'>
              <h4 className='bold text-white mb-3'>Quick Links</h4>
              <ul className='list-unstyled p-0'>
                <li className='py-2'><Link to='/home' className='text-light text-decoration-none'>➔ Home Page</Link></li>
                <li className='py-2'><Link to='/about' className='text-light text-decoration-none'>➔ About Us</Link></li>
                <li className='py-2'><Link to='/' className='text-light text-decoration-none'>➔ Crackers Price List</Link></li>
                <li className='py-2'><Link to='/safetytips' className='text-light text-decoration-none'>➔ Safety Tips</Link></li>
                <li className='py-2'><Link to='/contactus' className='text-light text-decoration-none'>➔ Contact & Location</Link></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Copyright Bar */}
      <div className='mark-bg py-3 border-top border-danger'>
        <Container>
          <Row>
            <Col lg='12'>
              <div className='text-center regular text-white' style={{ fontSize: '14px', letterSpacing: '0.4px' }}>
                Copyright © {currentYear} <strong>Alagar Crackers</strong> (Sivakasi). All Rights Reserved. Celebrate Safely! 🪔
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;